import type { UntypedFunction } from '@mnd-frontend/ts';
import { NEUTRAL_WHITE, PURPLE_700, PURPLE_800 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

type StyledButtonProps = {
  $hide?: boolean;
  $open?: boolean;
  $icon?: boolean;
};

const FloatingActionButton = styled.button<StyledButtonProps>`
  background: ${PURPLE_700};
  color: ${NEUTRAL_WHITE};
  padding: 0.5rem;
  border-radius: 30px;
  border: none;
  line-height: ${props => props.$icon && 0};

  &:hover {
    background: ${PURPLE_800};
    color: ${NEUTRAL_WHITE};
  }
  &:focus {
    color: ${NEUTRAL_WHITE};
  }

  ${({ $hide }) => $hide && 'display: none;'}
  ${({ $open }) => $open && `background: ${PURPLE_800};`}
`;

const WidgetTrigger = ({
  children,
  svg,
  hide,
  open,
  onClick,
}: {
  children?: React.ReactNode;
  svg?: React.ReactElement;
  hide?: boolean;
  open?: boolean;
  onClick: UntypedFunction;
}) => {
  return (
    <FloatingActionButton type="button" $icon={!!svg} $hide={hide} $open={open} onClick={onClick}>
      {svg ?? children}
    </FloatingActionButton>
  );
};

export default WidgetTrigger;
